var map = {
	"./assets/thewest-digital-hero-cropped.jpg": 756,
	"./assets/thewest-digital-hero-variation-a-cropped.jpg": 757,
	"./assets/thewest-digital-hero-variation-a.jpg": 2671,
	"./assets/thewest-digital-hero-variation-b-cropped.jpg": 758,
	"./assets/thewest-digital-hero-variation-b.jpg": 2672,
	"./assets/thewest-digital-hero-variation-black-friday-cropped.jpg": 759,
	"./assets/thewest-digital-hero-variation-black-friday.jpg": 2673,
	"./assets/thewest-digital-hero-variation-experiment2-cropped.jpg": 760,
	"./assets/thewest-digital-hero-variation-experiment2.jpg": 2674,
	"./assets/thewest-digital-hero-variation-vanishing-cousins-cropped.jpg": 761,
	"./assets/thewest-digital-hero-variation-vanishing-cousins.jpg": 2675,
	"./assets/thewest-digital-hero.jpg": 2676
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2670;